import { CloseIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Collapse,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useExperiencesStore } from '../../store/experiences';
import configureAxios from '../../axiosClient';
import { useUserStore } from '../../store/user';
import { useNavigate } from 'react-router-dom';
import { Process } from '../../interfaces';

interface EditWarningProps {
  open: boolean;
  isSubmitting: boolean;
  setOpenEditWarning: (open: boolean) => void;
}

const axiosClient = configureAxios();

const EditWarning = ({ open, setOpenEditWarning }: EditWarningProps) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { selectedExperience, selectedExperienceScenes } =
    useExperiencesStore();
  const organisation = useUserStore((state) => state.organisation);

  const close = () => {
    setOpenEditWarning(false);
  };

  const handleUpgrade = () => {
    setLoading(true);
    axiosClient
      .post(`experience/${selectedExperience.id}/upgrade`, {
        owner: organisation.organizationId,
        scene: selectedExperienceScenes[0].name,
      })
      .then((res) => {
        const isStatusOk = res.data.status === 'OK';
        if (isStatusOk) {
          // setLoading(false);
          // setOpenEditWarning(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!open) return;
    // check if experience is currently being edited already
    const url = `org/${organisation.organizationId}/processes/experience/${selectedExperience.id}`;
    axiosClient
      .get(url)
      .then((res) => {
        const isStatusOk = res.data.status === 'OK';
        if (isStatusOk) {
          const processes = res.data.data;
          // get upgrade to v2 status
          const upgradeToV2 = processes.filter(
            (process: Process) =>
              process.label === 'UPGRADE TO V2' &&
              ['SUBMITTED', 'STARTING', 'RUNNING'].includes(process.state)
          );
          if (upgradeToV2.length) {
            setLoading(true);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        // setLoading(false);
      });
  }, [open]);

  return (
    <Modal isOpen={open} onClose={close} size='md' isCentered autoFocus={false}>
      <ModalOverlay />
      <ModalContent
        height={['auto']}
        margin='auto'
        maxHeight='80vh'
        overflow='auto'
        padding={['20px']}
        borderRadius='16px'
        boxShadow='0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
      >
        <CloseIcon
          position='absolute'
          boxSize={[4]}
          cursor='pointer'
          color='#D6DBE4'
          _hover={{ color: 'black' }}
          transition='0.2s all'
          right={['20px']}
          top={['20px']}
          onClick={close}
        />
        <ModalHeader>
          <Text fontSize='xl' fontWeight='bold'>
            Update Experience
          </Text>
        </ModalHeader>
        <ModalBody>
          <Collapse in={!loading} animateOpacity>
            <Box>
              <Text fontSize='md'>
                Sorry, You need to upgrade to Experience V2 before you can edit
                this experience
              </Text>
            </Box>
            <Box display={'flex'} justifyContent={'center'} mt={4}>
              <Button
                textTransform='uppercase'
                width={['80%', '80%', '300px']}
                variant='outline'
                color='#08101D'
                background='white'
                fontFamily='Metal'
                fontSize={['14px', '14px', '14px']}
                borderRadius='30px'
                border='1px solid #D6DBE4'
                _hover={{
                  bg: '#D3BB8A',
                  borderColor: '#D3BB8A',
                }}
                isLoading={loading}
                type='submit'
                onClick={handleUpgrade}
              >
                Upgrade to V2
              </Button>
            </Box>
          </Collapse>

          <Collapse in={loading} animateOpacity>
            <Box
              m={['20px 0px']}
              width={['100%']}
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              alignItems='center'
              gap={2}
            >
              <Box
                display='flex'
                flexDirection='column'
                justifyContent='space-between'
                alignItems='center'
                gap={1}
              >
                <Box display='flex' alignItems='center' gap={1}>
                  <Text fontFamily='Normal' color='#08101D' fontSize={['14px']}>
                    Upgrading to V2:
                  </Text>
                </Box>
                <Spinner color='#08101D' />
              </Box>

              <Box textAlign='center'>
                <Text fontFamily='Normal' color='#08101D' fontSize={['12px']}>
                  Your experience is being processed.
                </Text>
                <Text fontFamily='Normal' color='#08101D' fontSize={['12px']}>
                  You can close this window now or view the status in processes
                  tab.
                </Text>
              </Box>

              <Button
                textTransform='uppercase'
                width={['200px']}
                variant='outline'
                color='#08101D'
                background='white'
                fontFamily='Metal'
                fontSize={['14px', '14px', '14px']}
                borderRadius='30px'
                border='1px solid #D6DBE4'
                _hover={{
                  bg: '#D3BB8A',
                  borderColor: '#D3BB8A',
                }}
                onClick={() => {
                  navigate('/processes');
                }}
              >
                View Processes
              </Button>
            </Box>
            <Box
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              alignItems='center'
            >
              <Button
                fontSize={['11px']}
                variant='link'
                fontFamily='Normal'
                textAlign='center'
                onClick={() => {
                  setLoading(false);
                  setOpenEditWarning(false);
                }}
              >
                {loading ? 'Close' : 'Cancel'}
              </Button>
            </Box>
          </Collapse>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EditWarning;
